import React, { memo, useMemo } from 'react';
import { LayoutDefault } from '@app/layouts';
import { WelcomeBanner } from '@app/common';
import { Container, FilterTab, FilterTabs } from '@app/components';
import { Card, CardContent } from 'components/ui/card';
import { Navigate, Route, Routes } from 'react-router-dom';
import { routeConfigHome } from 'config/routeConfig/home';

interface Props {}

function HomePage(props: Props) {
  const data = useMemo<FilterTab[]>(
    () => [
      {
        title: 'CMP',
        path: '/',
      },
      { title: 'Материалы', path: '/suppliers' },
      { title: 'Спецтехника', path: '/vehicles' },
      { title: 'Специалисты', path: '/specialists' },
    ],
    []
  );

  return (
    <LayoutDefault>
      <WelcomeBanner />
      <Container>
        <Card className="mb-4">
          <CardContent>
            <div className="overflow-x-auto no-scrollbar sm:overflow-visible flex-nowrap w-max min-w-full">
              <FilterTabs data={data} />
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent>
            <Routes>
              {Object.values(routeConfigHome).map(({ element, path }) => (
                <Route key={path} path={path} element={element} />
              ))}
              <Route path="*" element={<Navigate replace to="/" />} />
            </Routes>
          </CardContent>
        </Card>
      </Container>
    </LayoutDefault>
  );
}

export default memo(HomePage);
